module.exports = __webpack_public_path__ + "img/ccl_gallery8.b992e511.jpg";